import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'common/components/elements/icons';
import {
   OptionLableWrapper,
} from 'admin/views/site-designer/modules/sections/modules';

const AlignmentSection = ({
   options,
   value,
   isTextAlignment,
   name,
   onChange,
}) => {

   const getOptionName = (option) => {
      if('end' === option){
         return 'left';
      }
      if('start' === option){
         return 'right';
      }
      return option
   }
   return (
      <div className='flex gap-4'>
         {
            options.map((option, index) => {
               const isSelected = option === value;
               const optionName = getOptionName(option);
               return (
                  <OptionLableWrapper
                     key={ index.toString() }
                     isSelected={ isSelected }
                     title={ optionName }
                     onClick={ _ => onChange(name, option) }
                  >
                     {
                        isTextAlignment && (
                           <div className='h-6 w-6'>
                              <Icon
                                 name={ `alignment-${ optionName }` }
                                 size='lg'
                                 color='secondary'
                              />
                           </div>
                        )
                     }
                     {
                        !isTextAlignment && (
                           <div
                              className={ cx({
                                 'rounded flex border-2 p-1 w-16': true,
                                 'border-action': isSelected,
                                 'border-secondary': !isSelected,
                                 'justify-center': 'center' === option,
                                 'justify-left': 'left' === option,
                              }) }
                           >
                              <div
                                 className={ cx({
                                    'rounded-sm w-3 h-3': true,
                                    'bg-action': isSelected,
                                    'bg-secondary': !isSelected,
                                 }) }
                              />
                           </div>

                        )
                     }
                  </OptionLableWrapper>
               )
            })
         }
      </div>


   )
}


AlignmentSection.propTypes = {
   options: PropTypes.array,
   value: PropTypes.any,
   isTextAlignment: PropTypes.bool,
   onChange: PropTypes.func,
   name: PropTypes.string,
};

export default AlignmentSection;
